





















import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '../../../../common/utils';
import mapStore, { State } from '../../../../store/nexus';
@Component({
    components: {}
})
export default class Grid extends Vue {
    userInfo: Array<{
        entity: string;
        nexus: string;
        type: string;
        instance: string;
        cvt: string;
    }> = [];
    grid!: HTMLTableElement;
    createTr(items: any) {
        let html: string = '';
        Object.keys(items).forEach((key: string) => {
            const item: any = items[key];
            if (item.show) {
                html += `<td rowspan=${item.rowspan}>${item.text}</td>`;
            }
        });
        return html;
    }
    isTips(key: string, vo: any) {
        if (key === 'cvt') {
            let txt: string = vo.text;
            if (txt.length > 40) {
                return true;
            }
        }
        return false;
    }
    shapingData(data: any) {
        Object.keys(data).forEach((key: any) => {
            data[key] = {
                text: data[key],
                show: true,
                rowspan: 1
            };
        });
    }
    created() {
        // const entity: Function = utils.rowSpan();
        // const type: Function = utils.rowSpan();
        // this.userInfo.forEach((vo: any) => {
        //     this.shapingData(vo);
        //     entity(vo.entity);
        //     type(vo.type);
        // });
    }
    mounted() {
        this.grid = this.$refs.grid as HTMLTableElement;
        this.grid.classList.add('force-table');
        mapStore.groupGrid().forEach((vos: any) => {
            const entity: Function = utils.rowSpan();
            const type: Function = utils.rowSpan();
            const nexus: Function = utils.rowSpan();
            vos.forEach((vo: any) => {
                this.shapingData(vo);
                entity(vo.entity);
                type(vo.type);
                nexus(vo.nexus);
                this.userInfo.push(vo);
            });
        });
    }
}
